import { render, staticRenderFns } from "./ArticlesSlider.vue?vue&type=template&id=1c1e6bfd&"
import script from "./ArticlesSlider.vue?vue&type=script&lang=js&"
export * from "./ArticlesSlider.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports